import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restaura scroll al inicio al cambiar de ruta.
 * Si hay hash (#descarga), deja el comportamiento nativo del ancla.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, hash]);

  return null;
}
